import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { apiService } from "../services/axios";
import SharedComicList from "../components/SharedComicList";
import CategoryList from "../components/CategoryList";
import { translateCategoryCodeToEnglish, CATEGORY_CODE_TRANSLATIONS } from '../utils/categoryTranslations';

function SharedCollectionPage() {
    const { shareToken } = useParams();
    
    // Extraire le categoryCode depuis l'URL complète
    const location = useLocation();
    const currentPath = location.pathname;
    
    // Trouver la partie "la-collection-de-" et extraire le code de catégorie qui suit
    const collectionIndex = currentPath.indexOf('/la-collection-de-');
    let categoryCode = null;
    
    if (collectionIndex !== -1) {
        const remainingPath = currentPath.substring(collectionIndex + '/la-collection-de-'.length);
        const segments = remainingPath.split('/');
        const lastSegment = segments[segments.length - 1];
        
        // Vérifier si le dernier segment est un code de catégorie français
        const frenchCodes = Object.values(CATEGORY_CODE_TRANSLATIONS);
        categoryCode = frenchCodes.includes(lastSegment) ? lastSegment : null;
    }
    const [collection, setCollection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (shareToken) {
            apiService.getPublic(`/api/shared-collection/${shareToken}`)
                .then((response) => {
                    setCollection(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Erreur lors du chargement de la collection:', error);
                    setError('Impossible de charger la collection partagée');
                    setLoading(false);
                });
        }
    }, [shareToken]);

    if (loading) {
        return (
            <div className="hero-body">
                <div className="container">
                    <div className="has-text-centered">
                        <p>Chargement de la collection...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="hero-body">
                <div className="container">
                    <div className="notification is-danger">
                        <p>{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!collection) {
        return (
            <div className="hero-body">
                <div className="container">
                    <div className="notification is-warning">
                        <p>Collection non trouvée</p>
                    </div>
                </div>
            </div>
        );
    }

    // Traduire le code français de l'URL vers le code anglais utilisé par l'API
    const englishCategoryCode = categoryCode ? translateCategoryCodeToEnglish(categoryCode) : categoryCode;

    return (
        <div className="hero-body">
            <div className="container">
                <h1 className="title is-2">Collection de {collection.ownerFirstName}</h1>
                <CategoryList shareToken={shareToken} />
                <SharedComicList comics={collection.userComics} categoryCode={englishCategoryCode} />
            </div>
        </div>
    );
}

export default SharedCollectionPage;
